export default "__VITE_ASSET__e7fe1556__"